module.exports = __webpack_public_path__ + "static/media/tinyConnected.8dedb8f1.svg";